import React from "react";

// Traced from assets/images/willow-icon-color@2x.png on its 80px grid; the dot is its own shape so it can animate.
const LETTER_W_POINTS = "2.5,36 15,36 21,54 27,36 36,36 41.5,54 47.5,36 60,36 48,72.5 37.5,72.5 31.5,54 25.5,72.5 15,72.5";

export const WillowMark: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="-1.75 0 80 80" aria-hidden="true">
    <polygon className="letters" points={LETTER_W_POINTS} />
    <rect className="letters" x={61} y={36} width={13} height={36.5} />
    <circle className="dot" cx={67.5} cy={14} r={6.5} />
  </svg>
);
